import { useNavigate } from 'react-router';

import { FormikHelpers } from 'formik';

import { UsuarioProps } from '../types';

import { useFormContext } from 'context/FormContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useFormMutation } from 'mutations/useFormMutation';

export function useMutateUsuario() {
    const { mutate, isLoading } = useFormMutation();
    const { setContent } = useFormContext();
    const { hasPermission } = usePermissionsContext();
    const navigate = useNavigate();

    const handleSubmit = (formData: UsuarioProps, formik: FormikHelpers<UsuarioProps>): void => {
        if (
            formData.tipoUsuario?.tipoUsuarioEnum === 'FUNCIONARIO' &&
            formData.usuarioFuncionario &&
            typeof formData.usuarioFuncionario.fgAtivoCompra !== 'boolean'
        ) {
            formData.usuarioFuncionario.fgAtivoCompra = true;
        }

        mutate(
            {
                url: '/gestao/usuario',
                formik,
                formData,
                idField: 'idUsuario',
                preventRedirect: !hasPermission(['USUARIO_ALTERAR']),
            },
            {
                onSuccess: (response: any) => {
                    const { data } = response.data;

                    if (data && hasPermission(['USUARIO_ALTERAR'])) {
                        setContent({ usuarioAcessoGrupoEconomicos: [], ...data });
                    } else {
                        navigate('/cadastro/usuario');
                    }
                },
            },
        );
    };

    return { handleSubmit, isLoading };
}
